@if (titleText || titleTranslationKey) {
  <h3> <span *transloco="let t">{{ titleTranslationKey ? t(titleTranslationKey) :
  titleText}}</span> </h3>
}


@if (!hideProgressIndicator && (surveyProgressValue === 0 || surveyProgressValue > 0)) {
  <progress-indicator-card-simple ngClass="hide-progress"
    [titleTranslationKey]="'tracking.progress'" [value]="surveyProgressValue"
  [unit]="'%'"></progress-indicator-card-simple>
}

@for (question of questions; track question) {
  <div>
    @if (question.class === 'MultipleChoiceQuestion') {
      <multisite-question-multiple-choice
        [question]="question"
        [feedback]="questionFeedbacks[question.question_id]"
        [showTryAgainButtonWithFeedback]="showTryAgainButtonWithFeedback"
        (submitResponse)="doSubmitResponse($event)"
        [loading]="loading"
        [error_message_translation_key]="error_message_translation_key"
        >
      </multisite-question-multiple-choice>
    }
    @if (question.class === 'LickertQuestion') {
      <multisite-question-lickert
        [question]="question"
        [feedback]="questionFeedbacks[question.id]"
        [showTryAgainButtonWithFeedback]="showTryAgainButtonWithFeedback"
        [surveyProgressValue]="surveyProgressValue"
        [surveyProgressUnit]="'%'"
        (submitResponse)="doSubmitResponse($event)"
        [loading]="loading"
        [error_message_translation_key]="error_message_translation_key"
        >
      </multisite-question-lickert>
    }
  </div>
}
@if (showNextButton) {
  <div>
    <button class="btn btn-primary" (click)="gotoNext()" [disabled]="disableNextButton"><span *transloco="let t">{{
    t('common.next')}}</span></button>
  </div>
}
<div class="row">
  @if (showSnapshotContext) {
    <div class="col-lg my-2">
      @if (snapshot && showSnapshotContext) {
        <snapshot-context
          [date]="snapshot.date"
          [title]="snapshot.title"
          [description]="snapshot.description"
          [cultures]="snapshot.cultures"
          [primary_culture_id]="snapshot.primary_culture_id"
        ></snapshot-context>
      }
    </div>
  }
  @if (showMultiRaters) {
    <div class="col-lg my-2">
      <multi-rater-list-card
        [raters]="raters"
      ></multi-rater-list-card>
    </div>
  }
</div>